angular.module('impactx.basket').controller('BasketActionToastCtrl', [
    '$scope',
    '$mdToast',
    '$context',
    '$redirect',
    'themeFactory',
    'message',
    'secondMessage',
    'action',
    BasketActionToastCtrl]);

function BasketActionToastCtrl($scope, $mdToast, $context, $redirect, themeFactory, message, secondMessage, action)
{
    $scope.theme = themeFactory.getTheme();
    $scope.message = message;
    $scope.secondMessage = secondMessage;
    $scope.action = action;

    this.redirectToBasket = function () {
        if ($context.hasSupplierBasket.value) {
            $redirect.redirectTo(null, "/supplierbasket/" + $context.hasSupplierBasket.id)
        }
        else {
            $redirect.redirectTo(null, "/basket");
        }
    };
}